<template>
  <v-card-actions :class="`py-4 full-width ${theme.appBar.other.bg} ${theme.appBar.other.color}--text`">
    <!-- :class="`${theme.bottomBar.clz} `" -->
    <div v-if="loadedHits === 0">
      <div class="pl-3 caption hint">{{ $t('search.noResults') }}</div>
    </div>
    <div v-else>
      <div class="caption">
        {{ searchResults.length }} Treffer {{ searchResults.length > virtualScrollKeepOption ? '(max. ' + virtualScrollKeepOption + ' angezeigt)' : '' }}
      </div>
      <div class="caption hint" v-if="!xs && !lastSearchWasAllSearch">{{ $t('search.bottomResult') }}</div>
    </div>

    <v-spacer></v-spacer>
    <v-btn class="ml-3" text :x-small="xs" :small="!xs" @click="$emit('onClose')" :class="`${theme.appBar.other.color}--text`">
      {{ $t('search.closeDialog') }}
    </v-btn>
  </v-card-actions>
</template>

<script>
import { mapState } from 'vuex';

import commonMixin from '@/mixins/common';
export default {
  name: 'SearchDialogBottomBar',
  mixins: [commonMixin],
  props: {
    loadedHits: Number,
    totalHits: Number,
    lastSearchWasAllSearch: Boolean,
  },
  computed: {
    ...mapState('search', ['searchResults', 'virtualScrollKeepOption']),
  },
};
</script>

<style scoped>
.hint {
  font-size: 0.5rem;
  opacity: 0.7;
}
</style>
